import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';

import { IAction } from '@r1-frontend/shared/types/Redux';

import { ECitySelect } from './index';

export type TSetSatellites = IAction<ECitySelect.SET_SATELLITES, ICitySatellite[]>

const setSatellites = (satellites: ICitySatellite[]): TSetSatellites => ({
    type: ECitySelect.SET_SATELLITES,
    payload: satellites,
});

export default setSatellites;
